// extracted by mini-css-extract-plugin
export default {"loginContainer":"SendMethod_loginContainer__4XBax","loginContainers":"SendMethod_loginContainers__B5Qy-"};